import "./TransmissionService.css";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
export default function TransmissionService() {
  return (
    <>
<Helmet>
  <title>
    Professional Transmission Service in Palwal | AutoCare
  </title>
    <meta
    name="description"
    content="Get expert transmission service for automatic & manual cars at AutoCare Palwal. We offer transmission oil change, fluid replacement & gearbox maintenance."
  />
  <link
    rel="canonical"
    href="https://car-repair-mechanic-palwal.netlify.app/services/transmission"
  />
</Helmet>
    <section className="transmission-section">
  <div className="transmission-container">

    {/* MAIN HEADING – TOP */}
    <h1 className="service-title">
      Professional Transmission Service for Automatic & Manual Cars
    </h1>

    {/* HERO IMAGE */}
    <div className="service-hero">
      <img
        src="../carServiceImages/transmission.webp"
        alt="Professional transmission service for automatic transmission cars in palwal"
        loading="lazy"
      />
    </div>

        <p className="service-desc">
        Your car’s <strong>transmission</strong> system is one of the most critical components that ensures smooth gear shifting and optimal performance. At <strong>AutoCare</strong>, we provide expert<strong> transmission service</strong> for all types of vehicles including<strong> automatic transmission cars and transmission trucks</strong>.

        Regular<strong> transmission oil</strong> and<strong> transmission fluid</strong> replacement helps prevent gear slipping, overheating, and costly repairs. Our trained mechanics use high-quality fluids and follow manufacturer-recommended procedures to keep your<strong> transmission automatic</strong> system running smoothly.
        </p>

        {/* AUTOMATIC TRANSMISSION SECTION */}
        <div className="service-flex">
          <div>
            <h2 className="service-subtitle">
              Automatic Transmission Service You Can Trust
            </h2>

            <p className="service-desc">
              Regular <strong>automatic transmission</strong> maintenance and
              <strong> oil transmission change</strong> keeps your car smooth and safe.
              Old <strong>transmission fluid</strong> can damage the gearbox.
            </p>
            <p>If you own an<strong> automatic transmission car</strong>, timely<strong> oil transmission change</strong> is essential for long-term reliability. Dirty or low<strong> transmission fluid</strong> can cause delayed gear shifts, jerking, and reduced fuel efficiency.</p>
            <p>At AutoCare Palwal, We offers:
                <ul>
                    <li>Complete automatic transmission service</li>
                    <li>Oil transmission change</li>
                    <li>Transmission inspection & diagnostics</li>
                    <li>Smooth gear performance restoration</li>
                </ul>
            </p>
            <p>Looking for<strong> oil transmission change near me</strong>? AutoCare Palwal is your trusted local solution for fast and reliable service.</p>
          </div>

          <img
            src="../carServiceImages/Automatic transmission service and repair.webp"
            alt="Automatic transmission service and repair  at AutoCare Palwal"
            className="service-img"
          />
        </div>

        {/* OIL CHANGE SECTION */}
        <div className="service-flex reverse">
          <img
            src="../carServiceImages/transmission-oil-change.webp"
            alt="Transmission oil change near me"
            className="service-img"
          />
          <div>
            <h2 className="service-subtitle">
              Transmission Oil & Fluid Change Service
            </h2>

            <p className="service-desc">
              We provide reliable <strong>transmission oil</strong> and
              <strong> transmission fluid</strong> replacement services.
              Searching for <strong>oil transmission change near me</strong>?
              AutoCare is your trusted solution.
            </p>
          </div>
        </div>
               <div>
            <h2 className="service-subtitle">
                Transmission Service for Cars & Trucks
            </h2>

            <p>Whether you drive a compact car or a heavy<strong> transmission truck</strong>, our technicians are equipped to handle all transmission types. From basic<strong> transmission service</strong> to advanced automatic gearbox maintenance, we ensure precision and care at every step.</p>
            <p>We also provide guidance through our<strong> transmission video checks</strong> and diagnostics so you understand the condition of your vehicle before service begins.</p>
          </div>
                  <div>
            <h2 className="service-subtitle">
                Why Choose AutoCare for Transmission Service?
            </h2>
            <ul>
               <li>✔ Certified mechanics</li>
               <li>✔ High-quality transmission fluid</li>
               <li>✔ Affordable pricing</li>
               <li>✔ Service for transmission cars & trucks</li>
               <li>✔ Trusted automatic transmission experts</li>
            </ul>
          </div>

        {/* CTA */}
        <div className="service-cta">
          <h3>Book Your Transmission Service Today</h3>
          <p>
            Get professional <strong>transmission service</strong> and enjoy smooth driving.
          </p>
          <Link to="/contact" className="cta-btn">Contact Us</Link>
        </div>

      </div>
    </section>
    </>
  );
}
